/**
 * CSS classes for the builder-form when handling deliveries for One Click
 */
export enum FieldClassesDeliveryBuilder {
  DELIVERY_METHOD_READONLY = 'col-md-3 text-capitalize mt-3',
  LOCATION = 'col-md-6 pushed retail-control text-capitalize mb-3',
  LOCATION_READONLY = 'col-md-7 pushed retail-control text-capitalize mt-3',
  PAYMENT_TERM = 'col-md-6 mb-3 retail-control text-capitalize',
  PAYMENT_TERM_READONLY = 'col-md-12 mb-3 retail-control text-capitalize',
  MULTIPRODUCT_PAYMENT_TERM = 'col-md-4 mb-3 retail-control text-capitalize',
  PRODUCT = 'col-md-6 mb-3 retail-control text-capitalize',
  RECEIVING_PERSON = 'col-md-4 mb-3 retail-control text-capitalize',
  STD_LOT = 'col-md-3 mb-3 retail-control text-capitalize',
  QUANTITY = 'col-md-4 mb-3 retail-control text-capitalize',
  UNIT = 'col-md-2 mb-3 retail-control',
}

/**
 * CSS classes for the builder-form when handling customer pick-up for One Click
 */
export enum FieldClassesPickUpBuilder {
  DELIVERY_METHOD_READONLY = 'col-md-3 text-capitalize mt-3',
  LOCATION = 'col-md-6 pushed retail-control text-capitalize mb-3',
  LOCATION_READONLY = 'col-md-7 pushed retail-control text-capitalize mt-3',
  PRODUCT = 'col-md-7 mb-3 retail-control text-capitalize',
  MULTIPRODUCT_PRODUCT = 'col-md-6 retail-control text-capitalize',
  QUANTITY = 'col-md-3 mb-3 retail-control',
  PAYMENT_TERM = 'col-md-5 mb-3 retail-control text-capitalize',
  PAYMENT_TERM_READONLY = 'col-md-12 mb-3 retail-control text-capitalize',
  PLANT = 'col-md-7 mb-3 retail-control text-capitalize',
  MULTIPRODUCT_PLANT = 'col-md-6 retail-control text-capitalize',
  RECEIVING_PERSON = 'col-md-7 mb-3 retail-control text-capitalize',
  UNIT = 'col-md-2 mb-3 retail-control',
}

/**
 * CSS classes for the builder-form when handling customer own-freight for One Click
 */
export enum FieldClassesOwnFreightuilder {
  DELIVERY_METHOD_READONLY = 'col-md-3 text-capitalize mt-3',
  LOCATION = 'col-md-6 pushed retail-control text-capitalize mb-3',
  LOCATION_READONLY = 'col-md-7 pushed retail-control text-capitalize mt-3',
  PRODUCT = 'col-md-6 mb-3 retail-control text-capitalize',
  QUANTITY = 'col-md-3 mb-3 retail-control',
  PAYMENT_TERM = 'col-md-4 mb-3 retail-control text-capitalize',
  PAYMENT_TERM_READONLY = 'col-md-12 mb-3 retail-control text-capitalize',
  UNIT = 'col-md-2 mb-3 retail-control',
}
